import { z } from 'zod';

const addressSchema = z.object({
  street_address: z.string().min(1, { message: 'Street address is required' }),
  city: z.string().min(1, { message: 'City is required' }),
  state_province_region: z.string().min(1, { message: 'State / Province / Region is required' }),
  postal_zip_code: z.string().min(1, { message: 'Postal / Zip Code is required' }),
  country: z.string().min(1, { message: 'Country is required' }),
  time_zone: z.string().min(1, { message: 'Time zone is required' })
});

const currentBusinessSolutionSchema = z.object({
  telephony_voip_provider: z.string().min(1, { message: 'Telephony / VoIP Provider is required' }),
  other_providers: z.any().optional()
});

export const onboardingFormSchema = z.object({
  onboarding_form: z.object({
    business_legal_name: z.string().min(1, { message: 'Business Legal Name is required' }),
    industry: z.string().min(1, { message: 'Business Industry is required' }),
    website_url: z
      .string()
      .min(1, { message: 'Website URL is required' })
      .refine(
        (val) => {
          const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
          return urlPattern.test(val);
        },
        { message: 'Invalid URL' }
      )
      .transform((val) => {
        if (!val.startsWith('http')) {
          return `https://${val}`;
        }
        return val;
      }),
    primary_contact_name: z.string().min(1, { message: 'Primary Contact Person is required' }),
    primary_contact_email: z
      .string()
      .min(1, { message: 'Primary Contact Email is required' })
      .email({ message: 'Please enter a valid email address' }),
    primary_contact_phone: z.string().min(1, { message: 'Primary Contact Phone is required' }),
    ticket_reference: z.string().optional(),
    faq_question_set: z.string().min(1, { message: 'Category is required' }),
    available_integration_ids: z
      .array(z.union([z.number().min(1), z.string().min(1)]))
      .min(1, { message: 'EHR / EMR / PMS / CRM is required' }),

    address: addressSchema,
    current_business_solution: currentBusinessSolutionSchema,
    source: z.string().optional()
  })
});

export type OnboardingFormSchema = z.infer<typeof onboardingFormSchema>;
